import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const ExecutionTesterHeader = ({ template }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    const fallback = '/templates';
    const from = location.state?.from || fallback;
    navigate(from, { replace: false });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
      <IconButton onClick={handleBack} sx={{ mr: 2 }}>
        <ArrowBackIcon />
      </IconButton>
      <Box>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          Execution Tester
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          {template?.name || 'Template'} - Test and execute prompts
        </Typography>
      </Box>
    </Box>
  );
};

export default ExecutionTesterHeader;
